export default __webpack_public_path__ + "static/media/detail-2.360ceef5.png";